import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./css/IIITHWriteUpOne.css";

const IIITHWriteupTwo = () => {
  return (
    <div className="accordion-wrapper intern-bg">
      <h1 className="heading-text-3">Know More</h1>

      <div className="accordion-card">
        {/* About IIIT Hyderabad */}
        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">About IIIT Hyderabad</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p>
              The International Institute of{" "}
              <b>Information Technology Hyderabad (IIIT-Hyderabad or IIIT-H)</b>{" "}
              is a premier deemed university, founded as a non-profit
              public-private partnership <b>(N-PPP)</b>, located in Hyderabad,
              India. It is the first IIIT in India under this model.
            </p>
          </AccordionDetails>
        </Accordion>

        {/* Mode of Entrance */}
        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Mode of Entrance</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              <li>UGEE for Undergraduate Programs (Dual Degree B.Tech + MS)</li>
              <li>LEEE for Undergraduate Programs (Dual Degree B.Tech + MS)</li>
              <li>PGEE for Postgraduate Programs (M.Tech, MS, PhD)</li>
            </ul>
          </AccordionDetails>
        </Accordion>

        {/* About LEEE */}
        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">About LEEE</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p>
              The <b>LEEE mode</b> is for lateral entry to dual degree
              programmes. Graduates of the dual degree programmes earn two
              degrees: B.Tech and Master of Science by Research. The Masters
              degree requires completion of a research thesis. The programme
              prepares students for research-oriented jobs and higher studies.
              The duration of the programme is 4 years.
            </p>
            <p>
              <b>Eligibility (ECD Program):</b> Applicants completing their 4
              Semesters of B.E. / B.Tech. in ECE / ETE / EIE / EEE / IoT /
              Instrumentation and Control Engineering / Electronics and Computer
              Engineering by July 2026.
            </p>
            <p>
              Applicants with a keen interest in a research programme and/or an
              aggregate of 80% marks (or 8/10 CGPA) are strongly encouraged to
              apply.
            </p>

            <h4>Exam</h4>
            <p>
              Applicants in this mode need to appear for a computer-based
              lateral entry entrance examination (LEEE) conducted by IIIT
              Hyderabad, consisting of:
            </p>
            <ul>
              <li>Aptitude Test – 60 Minutes</li>
              <li>Subject Test – 120 Minutes</li>
            </ul>
            <p>There will be negative marking of 25% for wrong answers.</p>

            <h4>Syllabus for LEEE ECE</h4>
            <ul>
              <li>Digital Logic</li>
              <li>Circuit Theory and Networks</li>
              <li>Electronic Devices and Circuits</li>
              <li>Signals and Systems</li>
              <li>Engineering Mathematics (Linear Algebra, Calculus)</li>
            </ul>
            <p>
              <i>*With some unwritten syllabus</i>
            </p>

            <h4>Interview</h4>
            <p>
              Candidates shortlisted from this exam will have to clear an
              interview to gain admission. The decision on final offer of
              admission is solely based on the interview performance.
            </p>
          </AccordionDetails>
        </Accordion>

        {/* About PGEE */}
        <Accordion className="custom-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">About PGEE</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <p>
              The <b>PG Entrance Examination (PGEE)</b> is for admission into
              the following programs:
            </p>
            <ul>
              <li>
                Master of Technology (M.Tech) programme which is based on course
                work.
              </li>
              <li>
                Master of Science (M.S) and Doctor of Philosophy (Ph.D)
                programmes which require some course work and completion of a
                research thesis.
              </li>
            </ul>

            <h4>Programmes, Exam & Eligibility</h4>
            <p>
              <b>Minimum grade criteria:</b> 60% or equivalent in qualifying
              degree would be needed for admission in M.S program of Electronics
              and Communication.
            </p>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <img className="responsive-image-2" src="./IIITH/table.png" />
            </div>
            <p>
              <b>
                <i>This table is taken from IIIT HYD website</i>
              </b>
            </p>

            <h4>PGEE Exam Structure for ECE</h4>
            <ul>
              <li>General Aptitude Paper – 90 Minutes</li>
              <li>Subject Paper – 90 Minutes</li>
            </ul>
            <p>
              Negative marking of 25% for wrong answers. The General Aptitude
              paper emphasizes on aptitude, reasoning, computers, and
              mathematics.
            </p>

            <h4>Syllabi for Subject Papers</h4>
            <p>
              <b>1. Engineering Mathematics:</b>
            </p>
            <ul>
              <li>
                <b>Linear Algebra:</b> Matrices, Rank, Determinants, Eigenvalues
                and Eigenvectors.
              </li>
              <li>
                <b>Calculus:</b> Integration, Differentiation, Limits,
                Continuity, Series, Maxima, Minima, ODEs, Boundary Value
                Problems.
              </li>
            </ul>

            <p>
              <b>2. Electronics and Communications Engineering:</b>
            </p>
            <ul>
              <li>Circuit Theory and Networks</li>
              <li>Electronic Devices and Circuits</li>
              <li>Signals and Systems</li>
              <li>Probability Theory and Random Processes</li>
              <li>Laplace and Fourier Transforms</li>
              <li>Communication Theory</li>
              <li>Digital Signal Processing</li>
              <li>Digital Logic</li>
            </ul>

            <p>Exam process remains same for LEEE and PGEE modes.</p>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default IIITHWriteupTwo;
